import AddHospital from './AddHospital';

export default AddHospital;
